import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import VehicleTransportModel from "../../models/masters/vehicletransport-model";
import axios, { AxiosError } from "axios";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/VehicleTransport/GetAllVehicleTransport";// //{/api/VehicleTransport/GetAllVehicleTransport}`)  //// "https://localhost:7054/api/VehicleTransport/GetAllVehicleTransport";
export const useGetVehicleTransports = createQuery<
  VehicleTransportModel[],
  null,
  AxiosError
>({
  queryKey: ["keyVehicleTransportlist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});